export type StaffClub = { orgId: string; name: string }

/**
 * THE CLUB A PLAYER CARD IS OPENED FROM, or `null` for the ordinary platform card. All three
 * must hold: the URL names a club, the viewer is staff of it, and it is one of the viewer's OWN
 * organizations — the name comes from there, never from the URL or the card's data.
 */
export function resolveStaffClub(
  orgId: string | null | undefined,
  isStaffOf: boolean,
  organizations: ReadonlyArray<{ orgId: string; name?: string }>,
): StaffClub | null {
  const id = String(orgId || '').trim()
  if (!id || !isStaffOf) return null
  const own = organizations.find((org) => org.orgId === id)
  const name = String(own?.name || '').trim()
  return name ? { orgId: id, name } : null
}
